// Third-party
import clsx from 'clsx';

// Hooks
import { useMessageFilter } from '@/utils/hooks/conversations/useMessageFilter';

// Constants/Libs/Types
import { MESSAGE_FILTER_META } from '@/components/pages/conversations/SocialInbox/const';

// Components
import {
    ConversationMessageList,
    SocialInboxHeader
} from '@/components/pages/conversations/SocialInbox';

interface SocialInboxMessageListProps {
    className?: string;
}

export const SocialInboxMessageList = ({ className }: SocialInboxMessageListProps) => {
    const { messageFilter } = useMessageFilter();

    return (
        <div
            className={clsx(
                `flex flex-col gap-5 overflow-hidden bg-white pr-4 dark:bg-icoDarkMode-deepBlack`,
                className
            )}>
            <SocialInboxHeader />

            {messageFilter === MESSAGE_FILTER_META.dm.key ? null : <ConversationMessageList />}
        </div>
    );
};
